import React from "react";
import "../../../../App.css";
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardNavBar from "components/layout/DashboardNavBar";
import CollaboratorsVacationsForm from "../collaboratorsVacations/CollaboratorsVacationsForm";
import { useQueryGetUserRuleset } from "../../../../hooks/DataFetching/HR/ScholarshipRecesses/useQueryGetUserRuleset";
import { Redirect } from "react-router-dom";
import Transition from "components/layout/transition/Transition";

const CallViewMyVacations = ({ match }) => {
  if (localStorage.getItem("auth-token") !== null) {
    var auth = JSON.parse(localStorage.getItem("auth-token"));
  }

  const { isFetching, isSuccess, data } = useQueryGetUserRuleset(auth.id);

  if (isSuccess) {
    if (data === "Bolsista") {
      return (
        <Transition loading={isFetching} newDesign>
          <Redirect to={{ pathname: "/forbidden" }} />
        </Transition>
      );
    }
  }

  return (
    <div>
      <DashboardNavBar />
      <SideBar />
      <Transition loading={isFetching} newDesign>
        <CollaboratorsVacationsForm
          userId={auth.id}
          context={"view"}
          myVacations={true}
        />
      </Transition>
    </div>
  );
};

export default CallViewMyVacations;
